// src/store/slices/formSlice.ts
import { createSlice } from '@reduxjs/toolkit';

// Define initial state
interface FormState {
  isDirty: boolean;
}

const initialState: FormState = {
  isDirty: false
};

// Create the slice
const formSlice = createSlice({
  name: 'form',
  initialState,
  reducers: {
    setFormDirty: (state) => {
      state.isDirty = true;
    },
    setFormClean: (state) => {
      state.isDirty = false;
    }
  }
});

export const { setFormDirty, setFormClean } = formSlice.actions;

export default formSlice.reducer;
